import React from 'react';
import { useNetwork } from '../../context/NetworkContext';
import './NetworkBanner.css';

export default function NetworkBanner() {
  const { isOnline, isChecking, checkRealConnection } = useNetwork();

  if (isOnline) return null; // اگر آنلاین بود، هیچی نشان نده

  return (
    <div className="network-banner-wrapper">
      <div className="network-banner">
        <div className="network-banner-content">
          <span className="network-icon">⚠️</span>
          <span className="network-text">اتصال شما به اینترنت قطع شده است. (برنامه در حالت آفلاین)</span>
        </div>
        <button 
          className={`network-retry-btn ${isChecking ? 'loading' : ''}`} 
          onClick={checkRealConnection} 
          disabled={isChecking}
        >
          {isChecking ? 'در حال بررسی...' : 'تلاش مجدد'}
        </button>
      </div>
    </div>
  );
}